<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1>Seleção de Responsável Financeiro da Rematrícula</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-row vs-w="12">
          <vs-col vs-w="3">
            <vs-input
              label="CPF/CNPJ do responsável: "
              v-mask="
                client.CGCCFO.length <= 14 ? '###.###.###-##' : '##.###.###/####-##'
              "
              v-model="client.CGCCFO"
              v-on:keyup.13="findClient(client.CGCCFO)"
            />
          </vs-col>
          <vs-col vs-w="3" v-if="client.CGCCFO.length <= 14">
            <vs-input
              type="date"
              label="Data de nascimento do responsável: "
              v-model="nascClient"
              v-on:keyup.13="findClient(client.CGCCFO)"
            />
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col>
            <vs-button
              :disabled="client.CGCCFO.length < 14"
              @click="findClient(client.CGCCFO)"
            >
              Localizar
            </vs-button>
          </vs-col>
        </vs-row>

        <vs-row v-if="errorClient">
          <vs-alert
            title="Atenção!"
            class="margin"
            color="danger"
            v-for="(error, i) in errorClient"
            :key="i"
          >
            {{ error }}
          </vs-alert>
        </vs-row>

        <!-- FORMULÁRIO CLIENTE -->
        <vs-row>
          <vs-card v-if="showClientForm">
            <div slot="header">
              <h3>Informações do responsável financeiro</h3>
            </div>
            <div class="spacing-children">
              <form>
                <vs-row>
                  <vs-col vs-w="8" vs-type="flex">
                    <vs-input
                      name="NOME"
                      type="text"
                      v-model="client.NOME"
                      :disabled="client.NOME != '' && client.PESSOAFISOUJUR != 'J'"
                      label="Nome e sobrenome"
                      :danger="!client.NOME.length > 0"
                      danger-text="Campo obrigatório!"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-type="flex">
                    <vs-select
                      width="100%"
                      name="PESSOAFISOUJUR"
                      :disabled="true"
                      v-model="client.PESSOAFISOUJUR"
                      label="Tipo de Pessoa"
                      placeholder="Selecione"
                      :danger="!client.PESSOAFISOUJUR.length > 0"
                      danger-text="Campo obrigatório!"
                    >
                      <vs-select-item value="F" text="Pessoa Física" />
                      <vs-select-item value="J" text="Pessoa Jurídica" />
                    </vs-select>
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-type="flex">
                    <vs-input
                      name="NOMEFANTASIA"
                      type="text"
                      v-model="client.NOMEFANTASIA"
                      :disabled="client.PESSOAFISOUJUR == 'J' ? false : true"
                      label="Nome fantasia"
                    />
                  </vs-col>
                  <vs-col vs-w="4" vs-type="flex">
                    <vs-input
                      name="DTNASCIMENTO"
                      type="date"
                      v-if="client.PESSOAFISOUJUR != 'J'"
                      v-model="client.DTNASCIMENTO"
                      label="Data de nascimento"
                      :disabled="client.PESSOAFISOUJUR == 'J' || !editDate"
                      :danger="
                        client.DTNASCIMENTO == '' ||
                        validClientAge(client.DTNASCIMENTO)
                      "
                      danger-text="Campo obrigatório para pessoa física, cliente deve ser maior de 18 anos."
                    />
                  </vs-col>

                  <vs-col vs-w="2" vs-type="flex">
                    <vs-input
                      name="CGCCFO"
                      type="text"
                      v-model="client.CGCCFO"
                      v-mask="
                        client.CGCCFO.length <= 14
                          ? '###.###.###-##'
                          : '##.###.###/####-##'
                      "
                      label="CPF/CNPJ"
                      :disabled="true"
                      :danger="!client.CGCCFO.length > 0"
                      danger-text="Campo obrigatório!"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6" vs-type="flex">
                    <vs-input
                      name="TELEFONE"
                      type="text"
                      v-model="client.TELEFONE"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 1"
                      :danger="
                        !validTelephone(client.TELEFONE) ||
                        client.TELEFONE == client.TELEX
                      "
                      danger-text="Campo obrigatório, telefone 1 e 2 devem ser diferentes"
                    />
                  </vs-col>

                  <vs-col vs-w="6" vs-type="flex">
                    <vs-input
                      name="TELEX"
                      type="text"
                      v-model="client.TELEX"
                      v-mask="'(##) ####-#####'"
                      label="Telefone 2"
                      :danger="
                        !validTelephone(client.TELEX) ||
                        client.TELEFONE == client.TELEX
                      "
                      danger-text="Campo obrigatório, telefone 1 e 2 devem ser diferentes"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-type="flex">
                    <vs-input
                      name="EMAIL"
                      type="email"
                      v-model="client.EMAIL"
                      label="E-Mail"
                      :danger="
                        !client.EMAIL.length > 0 || !validEmail(client.EMAIL)
                      "
                      danger-text="Informe um e-mail válido."
                    />
                  </vs-col>
                </vs-row>
              </form>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-end">
                  <vs-button @click="saveAndGoFoward()">
                    Confirmar Dados e avançar
                  </vs-button>
                </vs-col>
              </vs-row>
              <vs-row v-if="errorFinal">
                <vs-alert title="Atenção!" class="margin" color="danger">
                  {{ errorFinal }}
                </vs-alert>
              </vs-row>
            </div>
          </vs-card>
        </vs-row>
      </section>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getStepsInformation,
  formatDateToUSA,
  updateStepsInformation,
} from "../helpers";
import PersonService from "../services/person";
import SerproService from "../services/serpro";
import MailingService from "../services/mailing";
import { updateDiscussion } from "../helpers";

export default {
  name: "ReEnrollmentFinancialResponsible",
  data: () => ({
    responsibleIsStudent: true,
    client: {
      NOMEFANTASIA: "",
      NOME: "",
      CGCCFO: "",
      TELEFONE: "",
      TELEX: "",
      EMAIL: "",
      PESSOAFISOUJUR: "",
      DTNASCIMENTO: "",
      isNew: false,
    },
    selectESTADO: [],
    selectCODMUNICIPIO: [],
    errorClient: null,
    errorStudent: null,
    errorFinal: null,
    showClientForm: false,
    showStudentForm: false,
    editDate: false,
    editDateStudent: false,
    editNameStudent: false,
    nascClient: "",
    resultSerpro: null,
    cpfmenor: false,
    course: null,
    offer: null,
    classData: null,
  }),

  mounted() {
    const stepsData = getStepsInformation();
    this.getStates();
    this.changeProvinces("RS");
    this.offer = stepsData.offer;
    this.classData = stepsData.classData;
    this.course = stepsData.course;
  },

  methods: {
    async find(cpf, type) {
      this.$vs.loading();
      let result = null;
      await new PersonService()
        .getPerson(cpf.replace(/\D/g, ""), null, this.offer.CODCURSO, type)
        .then(({ data }) => {
          result = data;
          console.log(result);
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      return result;
    },

    async findSerpro(cpf, nascimento) {
      this.resultSerpro = null;
      this.cpfmenor = false;
      this.$vs.loading();
      await new SerproService()
        .get(cpf.replace(/\D/g, ""), nascimento)
        .then(({ data }) => {
          this.resultSerpro = data;
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (!response) {
            this.errorClient.push("Falha de comunicação com o serviço Serpro.");
          } else {
            if (response.status == 400)
              this.errorClient.push("CPF ou data de nascimento inválidos");
            if (response.status == 404)
              this.errorClient.push(
                "CPF não localizado ou data de nascimento não confere com a Receita Federal"
              );
            if (response.status == 422 || response.status == 451) {
              this.errorClient.push(
                "Responsável financeiro precisa ser maior de 18 anos."
              );
              this.cpfmenor = true;
            }
            if (response.status >= 500)
              this.errorClient.push(
                "O serviço de busca CPF parece não estar respondendo. Aguarde uns instantes e tente novamente."
              );
          }
          this.$vs.loading.close();
        });
    },

    async findClient(cpf) {
      this.errorClient = [];
      this.errorStudent = [];
      let clientResult = null;
      this.showClientForm = false;
      //PESQUISA NA QI
      clientResult = await this.find(cpf, "C");
      if (clientResult) {
        if (clientResult.INADIMPLENTE == "1") {
          this.errorClient.push(
            "Cliente não pode ser selecionado, pois o mesmo consta como inadimplente."
          );
        }
        if (parseInt(clientResult.IDADE) < 18 && clientResult.IDADE != "0") {
          this.errorClient.push(
            "Responsável financeiro precisa ser maior de 18 anos."
          );
        }
        if (this.errorClient.length == 0) {
          Object.assign(this.client, clientResult);
          this.client.TELEFONE = this.client.TELEFONE1;
          this.client.TELEX = this.client.TELEFONE2;
          if (this.client.NOMEFANTASIA == "")
            this.client.NOMEFANTASIA = this.client.NOME;
          if (this.client.DTNASCIMENTO != "-") {
            this.client.DTNASCIMENTO = formatDateToUSA(
              this.client.DTNASCIMENTO
            );
            this.editDate = false;
          } else {
            this.client.DTNASCIMENTO = "";
            this.editDate = true;
          }
          this.showClientForm = true;
        }
      } else {
        if (cpf.length == 14) {
          //NÃO ACHA NA QI, PESQUISA NO SERPRO, EXCETO SE FOR CNPJ
          //SERPRO v3 EXIGE A DATA DE NASCIMENTO JUNTO COM O CPF
          if (!this.nascClient) {
            this.errorClient.push(
              "CPF não cadastrado na QI. Informe a data de nascimento do responsável e clique em Localizar."
            );
            return;
          }
          await this.findSerpro(cpf, this.nascClient);
          if (this.resultSerpro) {
            this.client.NOME = this.resultSerpro.nome;
            this.client.DTNASCIMENTO = formatDateToUSA(
              this.resultSerpro.nascimento
            );
            this.client.PESSOAFISOUJUR = "F";
            this.client.NOMEFANTASIA = this.client.NOME;
            this.editDate = false;
            this.showClientForm = true;
          } else {
            this.resetClient();
          }
        } else if (cpf.length > 14) {
          //SE FOR CNPJ MOSTRA O FORMULÁRIO PARA CADASTRO
          this.showClientForm = true;
          this.client.PESSOAFISOUJUR = "J";
          this.editDate = false;
        }
      }
    },

    resetClient() {
      this.client = {
        CGCCFO: "",
        NOMEFANTASIA: "",
        NOME: "",
        TELEFONE: "",
        TELEX: "",
        EMAIL: "",
        PESSOAFISOUJUR: "",
        DTNASCIMENTO: "",
      };
    },

    getStates() {
      new MailingService()
        .getStates()
        .then((res) => {
          this.selectESTADO = res.data;
        })
        .catch((error) => {
          console.error("Error trying to fetch states and provinces", error);
        });
    },

    changeProvinces(state) {
      new MailingService()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.selectCODMUNICIPIO = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
          this.$vs.notify({
            fixed: true,
            title: "Erro ao buscar cidades do estado " + state,
            color: "danger",
            icon: "close",
          });
        });
    },

    validTelephone(telephone) {
      var re = /^(\(?\d{2}\)?\s)(\d{4}?-\d{4,5})$/;
      return re.test(telephone);
    },

    validEmail(email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validClientAge(birthDay) {
      return moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") < 18;
    },

    validStudentAge(birthDay) {
      return moment().diff(moment(birthDay).format("YYYY-MM-DD"), "years") <= 0;
    },

    validClientData() {
      this.errorClient = [];
      if (!this.validEmail(this.client.EMAIL))
        this.errorClient.push("E-mail do responsável financeiro inválido.");
      if (this.validClientAge(this.client.DTNASCIMENTO))
        this.errorClient.push(
          "Data de nascimento do responsável inválida. Lembramos que o responsável financeiro precisa ter 18 anos completos."
        );
      if (!this.validTelephone(this.client.TELEFONE))
        this.errorClient.push("Telefone 1 do responsável inválido.");
      if (!this.validTelephone(this.client.TELEX))
        this.errorClient.push("Telefone 2 do responsável inválido.");
      if (this.client.NOME == "")
        this.errorClient.push("O nome do cliente precisa ser preenchido");
      //return this.errorClient;
    },

    async saveClient() {
      const clientData = {
        NOMEFANTASIA: this.client.NOMEFANTASIA,
        NOME: this.client.NOME,
        CGCCFO: this.client.CGCCFO.replace(/\D/g, ""),
        TELEFONE: this.client.TELEFONE.replace(/\D/g, ""),
        TELEX: this.client.TELEX.replace(/\D/g, ""),
        EMAIL: this.client.EMAIL,
        PESSOAFISOUJUR: this.client.PESSOAFISOUJUR,
        DTNASCIMENTO: this.client.DTNASCIMENTO,
        CODCOLCFO: this.client.CODCOLIGADA,
        CODCFO: this.client.CODCFO,
        CEP: this.client.CEP == "-" ? "" : this.client.CEP,
        RUA: this.client.RUA == "-" ? "" : this.client.RUA,
        NUMERO: this.client.NUMERO == "-" ? "" : this.client.NUMERO,
        COMPLEMENTO:
          this.client.COMPLEMENTO == "-" ? "" : this.client.COMPLEMENTO,
        CODETD: this.client.ESTADO == "-" ? "" : this.client.ESTADO,
        CODMUNICIPIO:
          this.client.CODMUNICIPIO == "-" ? "" : this.client.CODMUNICIPIO,
        BAIRRO: this.client.BAIRRO == "-" ? "" : this.client.BAIRRO,
        TIPORUA: (this.client.TIPORUA == "-" || !this.client.TIPORUA )?"":this.client.TIPORUA,
        isNew: this.client.isNew,
      };
      await new PersonService()
        .newClientPerson(clientData)
        .then(({ data }) => {
          const result = data.split(";");
          this.client.CODCFO = result[1];
          this.client.CODCOLCFO = result[0];
        })
        .catch(( error ) => {
          this.errorClient.push(
            "Erro na tentativa de criar ou atualizar um registro de cliente: " + error.response.data.error
          );
        });
    },

    async saveAndGoFoward() {
      this.errorClient = [];
      this.errorFinal = null;
      this.validClientData();
      if (this.errorClient.length == 0) {
        this.$vs.loading();
        if (!this.client.CODCFO) this.client.isNew = true;
        else this.client.isNew = false;
        await this.saveClient();
        this.$vs.loading.close();
      } //fecha if - se não tem erros no cliente
      if (
        //se não deu erro, segue adiante
        this.client.CODCFO != "" &&
        this.errorClient.length == 0
      ) {
        updateDiscussion("Selecionou Responsável e Estudante", {
          cpfResponsavel: this.client.CGCCFO,
        }).finally(() => {
          updateStepsInformation({
            client: this.client,
          });
          this.$router.push("/reviewInformation");
        });
      } else {
        this.errorFinal = `Não é possível seguir adiante`;
      }
    },
  },
};
</script>
